/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDeleteActionPlan } from '@/hooks/v2/useDeleteActionPlan';
import { useResolution886Report } from '@/context/Resolution886Report';
import { useGetResolution886ReviewResults } from '@/hooks/v2/resolution-886';
import { useGetCategoryResultList } from '@/hooks/v2/resolution-886/useGetCategoryResultList';

export interface ActionPlanData {
	risk_factor: string;
	risk: string;
	action_plan_name: string;
	due_date: string | null;
}

interface Parameters {
	organization_id: string;
	company_id: string;
	review_id: string;
	report_id: string;
	activity_id: string;
}

export function useActionPlan(params: Parameters) {
	const { form, report } = useResolution886Report();
	const { mutateAsync: deleteActionPlan } = useDeleteActionPlan();
	const { isLoading: isLoadingGetCategoryResultList, data, refetch } = useGetCategoryResultList(params);

	const organization_id = form.getFieldValue(['general_information', 'organization_id']);
	const company_id = form.getFieldValue(['general_information', 'company_id']);
	const review_id = form.getFieldValue(['general_information', 'review_id']);

	const {
		data: reviewResults,
		refetch: refetchReviewResults,
		isFetching: isLoadingGetReviewResults
	} = useGetResolution886ReviewResults({
		organization_id,
		company_id,
		review_id,
		report_id: report!.id
	});

	function validateActionPlanByRisk(): boolean {
		const validate: boolean[] = [];

		reviewResults?.assessments.forEach((assessment) => {
			const action_plan_failed = assessment.category_results.some(
				(category) => category.risk !== 'TOLERABLE' && category.action_plan === null
			);

			if (action_plan_failed) {
				validate.push(true);
			}
		});

		return validate.some((item) => item);
	}

	async function handleOnDelete(actionPlanId: string): Promise<void> {
		await deleteActionPlan({
			organization_id: params.organization_id,
			company_id: params.company_id,
			ids: [actionPlanId]
		});
		refetch();
	}

	useEffect(() => {
		refetchReviewResults();
	}, [data]);

	const isLoading = isLoadingGetReviewResults || isLoadingGetCategoryResultList;

	return {
		data,
		isLoading,
		handleOnDelete,
		validateActionPlanByRisk
	};
}
